import type { FC } from 'react';
import { Navigate, Route } from 'react-router-dom';
import { ThrowNotFound } from 'src/components/feedback/not-found';
import { RootRoutes } from 'src/components/root-routes';
import { StorageLocationsOverview } from 'src/pages/storage/locations';
import { StorageLocationsNewRoot } from 'src/pages/storage/locations-new';
import { StorageOffers } from 'src/pages/storage/offers';
import { StorageOffersNewRoot } from 'src/pages/storage/offers-new';

export const StorageRoot: FC = () => {
  return (
    <RootRoutes>
      {/* Old Storage - Monolith */}
      <Route
        path="/storage"
        element={<Navigate to="/storage/offers" replace />}
      />
      <Route path="/storage/offers" element={<StorageOffers />} />
      <Route path="/storage/locations" element={<StorageLocationsOverview />} />

      {/* New Storage - Storage Service */}
      <Route
        path="/storage/locations-new/*"
        element={<StorageLocationsNewRoot />}
      />
      <Route path="/storage/offers-new/*" element={<StorageOffersNewRoot />} />

      <Route path="*" element={<ThrowNotFound />} />
    </RootRoutes>
  );
};
